import { CMSContent, useAssets } from '@/core';
import type { MetaImage, MetaImageResponse } from '@/model';

export const resolveImage = async (imageData: Partial<CMSContent<MetaImageResponse>>): Promise<MetaImage> => {
  const { fetchAsset, getAssetById } = useAssets();
  let image;

  if (imageData && imageData?.content?.assetId) {
    let asset = getAssetById(imageData.content.assetId);

    if (!asset) {
      await fetchAsset(imageData.content.assetId);
      asset = getAssetById(imageData.content.assetId);
    }

    image = {
      src: asset?.url,
      alt: imageData.content.altText,
    };
  }

  return image;
};
